import { useTranslation } from 'react-i18next';
import { WriteReview } from 'autogen/translation-keys/trans-website-shared-buttons';
import { ButtonWithIcon, ButtonWithSpinner } from 'components/Button';
import Icon from 'components/Icon';
import type { ProductActionProps } from '../../shared/types';
import openWriteReview from './action';

export function WriteReviewButton({ params, trackingInfo, children, ...restProps }: ProductActionProps['WriteReview']) {
    const { t } = useTranslation();

    return (
        <ButtonWithSpinner onClick={() => openWriteReview({ params, trackingInfo })} type="button" {...restProps}>
            {children || t(WriteReview)}
        </ButtonWithSpinner>
    );
}

export function WriteReviewButtonCompact({ params, trackingInfo, ...restProps }: ProductActionProps['WriteReview']) {
    const { t } = useTranslation();

    return (
        <ButtonWithIcon
            icon={<Icon type="ChevronRight" size={16} />}
            onClick={() => openWriteReview({ params, trackingInfo })}
            type="button"
            aria-label={t(WriteReview)}
            {...restProps}
        />
    );
}

export default Object.assign(WriteReviewButton, {
    Compact: WriteReviewButtonCompact
});
